import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SupportPage: React.FC = () => {
  const { t } = useTranslation('support');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginRight: 30 }}>
      <Typography variant="h4" component="h4">
        {t('title')}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {t('privacy.text')}{' '}
        <a
          href="https://www.walkwithpath.com/policies/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('privacy.linkText')}
        </a>
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {t('contact.text')}{' '}
        <a href="mailto:dashboard-support@walkwithpath.com">
          dashboard-support@walkwithpath.com
        </a>
      </Typography>
    </Box>
  );
};

export default SupportPage;
